import { AxiosResponse } from 'axios';

import { carmaBizClient } from 'src/services/instance/carmaBizClient';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';

/**
 * Fetch a vehicle detail
 */
export const getVehicleByKey = async (key: string) => {
  const response: AxiosResponse<ProductDetailsPayload> = await carmaBizClient.get(`/vehicles/${key}`, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
};

export const fetchVehicleDetail = async (sku: string) => {
  const url = `${process.env.REACT_APP_BIZ_API_URL}/vehicles/${sku}`;
  const result = await fetch(url, {
    headers: { 'Content-Type': 'application/pdp+json' },
    next: {
      revalidate: 300,
      tags: ['pdp', `pdp/${sku}`],
    },
  });

  if (!result.ok) {
    throw new Error(`Failed to fetch data ${url}`);
  }

  const parsedResult = await result.json();

  return parsedResult as ProductDetailsPayload;
};
